<app-radio
  [label]="label"
  [text]="text"
  [helperText]="helperText"
  [horizontalAlign]="horizontalAlign"
  [customErrors]="customErrors"
  [formControl]="control"
  [options]="yesNoSelectOptions"
  [readonly]="readonly"
/>
